module.exports = __webpack_public_path__ + "img/svg/background-error-stain2.328196caa895607776abe8fb3c8f3521.svg";